<template>
  <section class="studio-tool-shell">
    <marketing-tool-header eyebrow="Studioverwaltung" :title="title" :description="description" :icon="icon">
      <template v-if="$slots.actions" v-slot:actions>
        <slot name="actions"></slot>
      </template>
    </marketing-tool-header>

    <main class="studio-tool-content">
      <slot></slot>
    </main>
  </section>
</template>

<script>
import MarketingToolHeader from "../../communication/MarketingToolHeader.vue"

export default {
  name: "StudioToolShell",
  components: { MarketingToolHeader },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "mdi-home-city-outline",
    },
  },
}
</script>

<style scoped>
.studio-tool-shell {
  --surface: rgba(255, 255, 255, 0.035);
  --surface-strong: rgba(255, 255, 255, 0.055);
  --border: rgba(255, 255, 255, 0.1);
  --border-strong: rgba(255, 255, 255, 0.16);
  --text: #f4f4f5;
  --text-soft: #d4d4d8;
  --muted: #a3a3a8;
  min-height: 100%;
  padding: 1.5rem;
  color: var(--text);
  font-size: 1rem;
}

.studio-tool-content {
  margin-top: 1.125rem;
}

@media (max-width: 59.9375rem) {
  .studio-tool-shell {
    padding: 1.125rem;
  }
}

@media (max-width: 37.4375rem) {
  .studio-tool-shell {
    padding: 0.75rem;
  }

  .studio-tool-content {
    margin-top: 0.75rem;
  }
}
</style>
